import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiOg } from './client';
const PATH = '/api/v1/admin/landing-tariff-cards';
const KEY = ['og', 'landing-tariff-cards'];
const LOCATIONS_PATH = '/api/v1/public/locations?language=ru&currency=RUB';
const orderedCards = (rows) => [...rows].sort((left, right) => left.sort_order - right.sort_order || left.id - right.id);
export function useLandingTariffCards(enabled = true) {
    return useQuery({
        queryKey: KEY,
        queryFn: () => apiOg('users', PATH),
        select: orderedCards,
        enabled,
        retry: false,
    });
}
export function useLandingLocations(enabled = true) {
    return useQuery({
        queryKey: ['og', 'landing-tariff-locations'],
        queryFn: () => apiOg('users', LOCATIONS_PATH),
        enabled,
        retry: false,
    });
}
export function useCreateLandingTariffCard() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (body) => apiOg('users', PATH, { method: 'POST', body }),
        onSuccess: (card) => {
            qc.setQueryData(KEY, (rows = []) => orderedCards([...rows, card]));
        },
    });
}
export function useReplaceLandingTariffCard() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, body }) => apiOg('users', `${PATH}/${id}`, { method: 'PUT', body }),
        onSuccess: (card) => {
            qc.setQueryData(KEY, (rows = []) => orderedCards(rows.map((row) => (row.id === card.id ? card : row))));
        },
    });
}
export function useActivateLandingTariffCard() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, isActive }) => apiOg('users', `${PATH}/${id}/activation`, {
            method: 'PATCH',
            body: { is_active: isActive },
        }),
        onSuccess: (card) => {
            qc.setQueryData(KEY, (rows = []) => orderedCards(rows.map((row) => (row.id === card.id ? card : row))));
        },
    });
}
export function useDeleteLandingTariffCard() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => apiOg('users', `${PATH}/${id}`, { method: 'DELETE' }),
        onSuccess: (_data, id) => {
            qc.setQueryData(KEY, (rows = []) => rows.filter((row) => row.id !== id));
        },
    });
}
